import "./reviewSlider"
import "./categoriesSlider"
import "./inThePakketSlider"
import "./scrollTop"
import "./filterShop"